import { render } from "./ShopWebsitesByLanguage.vue?vue&type=template&id=0fe448a6&scoped=true"
import script from "./ShopWebsitesByLanguage.vue?vue&type=script&lang=js"
export * from "./ShopWebsitesByLanguage.vue?vue&type=script&lang=js"

import "./ShopWebsitesByLanguage.vue?vue&type=style&index=0&id=0fe448a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fe448a6"]])

export default __exports__